import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import GuestListChild from "./GuestListChild";

const GuestList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <GuestListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default GuestList;
